__turbopack_context__.v({
  "featured_section": "styles-module-scss-module__Fh6n9q__featured_section",
  "featured_section_multiple_photos": "styles-module-scss-module__Fh6n9q__featured_section_multiple_photos",
  "featured_section_singular_photo": "styles-module-scss-module__Fh6n9q__featured_section_singular_photo",
  "featured_section_video": "styles-module-scss-module__Fh6n9q__featured_section_video",
  "is_mobile": "styles-module-scss-module__Fh6n9q__is_mobile",
  "tabs": "styles-module-scss-module__Fh6n9q__tabs",
});
